<template lang="pug">
	.publisher-settings
		.page-center-content(v-if="publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") {{publisher.title}} Settings
				.logo(@click="selectPublisher(publisher.id)")
					img(:src="`/Images/Icons/Publishers/${publisher.codename || publisher.id}.png?v=${(publisher['last_activity_time'] || publisher['create_date'] || new Date()).getTime()}`" :alt="publisher.title")
			.settings-groups-area
				.settings-section
					.settings-group
						.form-group
							label Name
							input.form-control(type="text" :value="publisher.title" @input="saveTitle($event.target.value)")
					.settings-group
						.form-group
							label Logotype
							br
							button.btn.btn-secondary(type="button" @click="replaceLogo")
								.icon.fa.fa-upload
								span &nbsp;&nbsp;Upload new png logotype
				.settings-section.amazon-s3
					label.no-margin Amazon S3
					.description.text-muted
						span Create a new Amazon S3 credentials for {{Metadata.Config['dashboard-page-title'] || ''}} to allow automatic upload your creatives code to CDN
					.columns-3
						.column
							.form-group
								label Access key id
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.accessKeyId')" @input="saveOption('AmazonS3', {'accessKeyId': $event.target.value})")
						.column
							.form-group
								label Secret access key
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.secretAccessKey')" @input="saveOption('AmazonS3', {'secretAccessKey': $event.target.value})")
						.column
							.form-group
								label Bucket name
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.bucketName')" @input="saveOption('AmazonS3', {'bucketName': $event.target.value})")
					.columns-3
						.column
							.form-group
								label Bucket region
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.bucketRegion')" @input="saveOption('AmazonS3', {'bucketRegion': $event.target.value})")
						.column
							.form-group
								label Bucket root path
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.rootPath')" @input="saveOption('AmazonS3', {'rootPath': $event.target.value})")
						.column
							.form-group
								label CDN url
								input.form-control(type="text" :value="_.get(publisher.options, 'AmazonS3.cdnUrl')" @input="saveOption('AmazonS3', {'cdnUrl': $event.target.value})")
					.columns-3
						.column
							.form-group.inline.no-margin
								label Include preview
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="!!_.get(publisher.options, 'AmazonS3.preview')" @change="saveOption('AmazonS3', {'preview': $event.target.checked})")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
				.settings-section.releases
					label Playable releases
					.description
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in playableReleases[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
				.settings-section.releases
					label Banner releases
					.description
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="release in bannerReleases[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="isReleaseActive(release)" v-on:change="changeReleaseStatus(release, $event.target.checked)")
									|{{release.title}}
				.settings-section.amazon-s3
					label Main menu
					.columns-4
						.column
							.form-group.inline.no-margin
								label Playables
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.playables') !== false" @change="saveOption('mainMenu', {'playables': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-banners']")
							.form-group.inline.no-margin
								label Banners
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.banners') !== false" @change="saveOption('mainMenu', {'banners': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-end-cards']")
							.form-group.inline.no-margin
								label End Cards
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.endCards') !== false" @change="saveOption('mainMenu', {'endCards': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-storyboards']")
							.form-group.inline.no-margin
								label Storyboards
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.storyboards') !== false" @change="saveOption('mainMenu', {'storyboards': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column(v-if="Metadata.Config['feature-editable-playables']")
							.form-group.inline.no-margin
								label AI Playables
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.editablePlayables') !== false" @change="saveOption('mainMenu', {'editablePlayables': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
					label.main-menu-markers Show folders for the markers
					.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no creative markers created so far
					.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="_.get(publisher.options, `mainMenu.markers.${marker}`)" v-on:change="saveOption('mainMenu', {markers: {[marker]: $event.target.checked}})")
									|{{marker}}
				.settings-section.files
					label Files
					.description.text-muted
						span File manager section for this company
					.columns-3
						.column
							.form-group.inline.no-margin
								label Files section
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'mainMenu.files') !== false" @change="saveOption('mainMenu', {'files': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column
							.form-group.inline.no-margin
								label Allow all users to create in root
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'files.allowRootCreate') !== false" @change="saveOption('files', {'allowRootCreate': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
						.column
							.form-group.inline.no-margin
								label All folders visible to everyone by default
								label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
									input.switch-input.form-check-input(type="checkbox" :checked="_.get(publisher.options, 'files.allVisibleByDefault') !== false" @change="saveOption('files', {'allVisibleByDefault': $event.target.checked}, 300)")
									span.switch-slider(data-checked="On" data-unchecked="Off")
									span.switch-handle
					.columns-3(v-if="User.currentUser.Tags['super-admin']")
						.column
							.form-group
								label Storage size (MB)
								input.form-control(type="number" min="0" :value="publisher.storage_size" @change="saveStorageSize($event.target.value)")
				.settings-section.publishers-access(v-if="User.currentUser.Tags['super-admin']")
					label {{Metadata.Config["dashboard-domain-title"]}} developers access
					.description.text-muted
						span Choose who from {{Metadata.Config["dashboard-domain-title"]}} team will have access to the «{{publisher.title}}» company
					.columns-3
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.['publishers-full-access'] || user.options?.access?.publishers?.[publisher.id]" :disabled="user.options?.access?.['publishers-full-access']" v-on:change="changeMraidioDeveloperAccess(user, $event.target.checked)")
									|{{user.name}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.['publishers-full-access'] || user.options?.access?.publishers?.[publisher.id]" :disabled="user.options?.access?.['publishers-full-access']" v-on:change="changeMraidioDeveloperAccess(user, $event.target.checked)")
									|{{user.name}}
						.column
							.multi-select-checkbox.form-check.checkbox(v-for="user in mraidioDevelopers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="user.options?.access?.['publishers-full-access'] || user.options?.access?.publishers?.[publisher.id]" :disabled="user.options?.access?.['publishers-full-access']" v-on:change="changeMraidioDeveloperAccess(user, $event.target.checked)")
									|{{user.name}}
				.settings-section.amazon-s3
					label Creative list panel
					.columns-3
						.column
							.form-group
								label Order field
								select.custom-select.custom-select-sm(@change="saveOption('UI', {'projectPlaneIconsSort': {type: $event.target.value, order: _.get(publisher.options, 'UI.projectPlaneIconsSort.order') || 'desc'}})")
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.type') === 'create_date' || !_.get(publisher.options, 'UI.projectPlaneIconsSort.type')" value="create_date") Date of creation
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.type') === 'title'" value="title") Title
						.column
							.form-group
								label Order direction
								select.custom-select.custom-select-sm(@change="saveOption('UI', {'projectPlaneIconsSort': {type: _.get(publisher.options, 'UI.projectPlaneIconsSort.type') || 'create_date', order: $event.target.value}})")
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.order') === 'asc'" value="asc") Ascending
									option(:selected="_.get(publisher.options, 'UI.projectPlaneIconsSort.order') === 'desc' || !_.get(publisher.options, 'UI.projectPlaneIconsSort.order')" value="desc") Descending
						.column
					//label Show creatives with specified markers
					//.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no creative markers created so far
					//.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeCreativeMarkerCreativeListViewability(marker, $event.target.checked)")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeCreativeMarkerCreativeListViewability(marker, $event.target.checked)")
									|{{marker}}
						.column
							.multi-select-checkbox.form-check.checkbox.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label
									input.form-check-input(type="checkbox" :checked="!publisher.options.projectMarkers[marker]['hideInProjectList']" v-on:change="changeCreativeMarkerCreativeListViewability(marker, $event.target.checked)")
									|{{marker}}
				.settings-section.creative-markers
					.columns-2.caption
						.column
							label Creative markers
						.row.content-left
							input.form-control.new-marker(type="text" v-model="newCreativeMarkerName")
							button.btn.btn-sm.btn-ghost-secondary(type="submit" @click="addCreativeMarker()")
								i.fa.fa-plus
								| &nbsp;&nbsp;Add marker
					.description.text-muted
						span You can create a list of markers (just use any text), specify behavior for each marker and assign it to any creative on the creative settings screen. In this case you will have the possibility to show / hide creatives with specific marker, or show it in separated folder in main menu.
					.description.text-muted(v-if="!projectMarkers[0].length")
						span There are no creative markers created so far
					.columns-3(v-if="projectMarkers[0].length > 0")
						.column
							.marker(v-for="marker in projectMarkers[0]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeCreativeMarker(marker)")
						.column
							.marker(v-for="marker in projectMarkers[1]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeCreativeMarker(marker)")
						.column
							.marker(v-for="marker in projectMarkers[2]")
								label.form-check-label {{marker}}
									i.fa.fa-remove(@click="removeCreativeMarker(marker)")
</template>

<script>
	import Screen 				from './../../mixins/screen'
	import { Auth } from "../../services/Auth";

	import { Metadata } 		from './../../services/Metadata'
	import { Layout } 			from './../../services/Layout'
	import { Publisher } 		from './../../services/Publisher'
	import { File } 			from './../../services/File'

	import SetupSettings 		from "./../../settings/settings.json";

	export default {
		name: "PublisherSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Publisher Data Changed",
				"User Changed:options.access",
				"Layout Page Showed:publisher-settings",
				"Metadata Loaded"
			]
		},
		data() {

			this.publisher = null;

			this.playableReleases = [[], [], []];
			this.bannerReleases = [[], [], []];
			this.projectMarkers = [[], [], []];
			this.mraidioDevelopers = [[], [], []];

			return {
				showed: true,
				publisherId: null,
				serverId: null,
				newCreativeMarkerName: ''
			}

		},
		methods: {
			collectData() {

				if (Layout.page === 'publisher-settings' && Layout.pageOptions?.publisherId) {

					this.publisherId = Layout.pageOptions.publisherId;
					this.serverId = Layout.pageOptions.serverId;

				} else if (Publisher.SelectedPublisher) {

					this.publisherId = Publisher.SelectedPublisher.id;
					this.serverId = Publisher.SelectedPublisher.server_id;

				} else {

					this.publisherId = null;
					this.serverId = null;

				}

				//Номер ноды берём из данных страницы: id издателей на разных нодах могут совпадать
				this.publisher = Publisher.findPublisher(this.publisherId, this.serverId);

				let releases = _.orderBy(_.filter(_.values(Metadata.Releases), release => release.enabled && release.type === 'playable'), 'priority');
				let partLength = Math.ceil(releases.length / 3);

				this.playableReleases[0] = releases.slice(0, partLength);
				this.playableReleases[1] = releases.slice(partLength, partLength * 2);
				this.playableReleases[2] = releases.slice(partLength * 2);

				releases = _.orderBy(_.filter(_.values(Metadata.Releases), release => release.enabled && release.type === 'banner'), 'priority');
				partLength = Math.ceil(releases.length / 3);

				this.bannerReleases[0] = releases.slice(0, partLength);
				this.bannerReleases[1] = releases.slice(partLength, partLength * 2);
				this.bannerReleases[2] = releases.slice(partLength * 2);

				if (this.publisher?.options?.projectMarkers) {

					let projectMarkers = _.keys(this.publisher.options.projectMarkers);
					partLength = Math.ceil(projectMarkers.length / 3);

					this.projectMarkers[0] = projectMarkers.slice(0, partLength);
					this.projectMarkers[1] = projectMarkers.slice(partLength, partLength * 2);
					this.projectMarkers[2] = projectMarkers.slice(partLength * 2);

				}

				let mraidioDevelopers = _.orderBy(_.filter(User.getUsers(), user => user.active && user.isAdmin), 'id');
				partLength = Math.ceil(mraidioDevelopers.length / 3);

				this.mraidioDevelopers[0] = mraidioDevelopers.slice(0, partLength);
				this.mraidioDevelopers[1] = mraidioDevelopers.slice(partLength, partLength * 2);
				this.mraidioDevelopers[2] = mraidioDevelopers.slice(partLength * 2);

			},
			saveTitle(title) {

				Server.sendWithTimeout({
					UpdatePublisherTitle: {
						publisherId: this.publisher.id,
						title
					}
				});

			},
			replaceLogo() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "image/png";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					let formData = new FormData();

					formData.append("publisherId", this.publisherId);
					formData.append("file", file);

					let url = 'http://' + SetupSettings["domain"] + '/publisher/uploadLogo';
					if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/publisher/uploadLogo';

					let xhr = new XMLHttpRequest();


					xhr.open("POST", url);
					Auth.authorizeRequest(xhr);

					xhr.upload.onprogress = function(e) {
						if (e.lengthComputable) {
							this.uploadProgress = e.loaded / e.total;
						}
					};

					xhr.upload.onloadstart = function(e) {
						this.isUploading = true;
					};

					xhr.upload.onloadend = function(e) {
						this.isUploading = false;
					};

					xhr.send(formData);

					document.body.removeChild(input);

				});

				input.click();

			},
			isReleaseActive(release) {

				if (!release['enabled']) return false;

				if (release.codename in (this.publisher.options['Releases'] || {})) return this.publisher.options['Releases'][release.codename];

				return release.options["enabledByDefault"];

			},
			changeReleaseStatus(release, isActive) {

				if (!this.publisher.options["Releases"]) this.publisher.options["Releases"] = {};
				this.publisher.options["Releases"][release.codename] = !!isActive;

				Server.sendWithTimeout({
					UpdatePublisherOptions: {
						publisherId: this.publisher.id,
						Releases: _.clone(this.publisher.options["Releases"] || {})
					}
				});

			},
			changeMraidioDeveloperAccess(user, isChecked) {

				Server.sendToServer({
					UpdateUserPublisherAccess: {
						userId: user.id,
						publisherId: this.publisher.id,
						grantAccess: isChecked
					}
				});

			},
			saveOption(optionsName, newData, delay = 1000) {

				if (!this.publisher.options[optionsName]) this.publisher.options[optionsName] = {};

				_.merge(this.publisher.options[optionsName], newData);

				Server.sendWithTimeout({
					UpdatePublisherOptions: {
						publisherId: this.publisher.id,
						[optionsName]: this.publisher.options[optionsName]
					}
				}, null, delay);

			},
			selectPublisher(publisherId) {

				//Переход к паблишеру: при смене ноды активные карты сервисов подменяются
				//картами этой ноды (Client/App/services/Publisher.js, selectPublisher)
				Publisher.switchPublisher(Publisher.findPublisher(publisherId));

				Layout.setPage('playables');

			},
			// Размер хранилища файлов паблишера (в мегабайтах) - только супер-админы
			saveStorageSize(size) {

				size = Math.max(0, Math.round(parseFloat(size) || 0));

				File.setStorageSize(this.publisherId, size);

			},
			addCreativeMarker() {

				Server.sendToServer({
					AddCreativeMarkerToPublisher: {
						publisherId: this.publisher.id,
						creativeMarkerName: this.newCreativeMarkerName
					}
				});

			},
			removeCreativeMarker(creativeMarkerName) {

				Server.sendToServer({
					RemoveCreativeMarkerFromPublisher: {
						publisherId: this.publisher.id,
						creativeMarkerName: creativeMarkerName
					}
				});

			},
			changeCreativeMarkerCreativeListViewability(creativeMarkerName, showInCreativeList) {

				Server.sendToServer({
					SetPublisherCreativeMarkerOption: {
						publisherId: this.publisher.id,
						creativeMarkerName: creativeMarkerName,
						optionName: 'hideInProjectList',
						optionValue: !showInCreativeList
					}
				});

			}
		}
	}
</script>

<style lang="sass" scoped>

	.publisher-settings
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.logo
					display: flex
					margin-left: auto
					padding: 10px
					cursor: pointer

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.settings-groups-area
				display: flex
				flex-direction: column
				flex-wrap: nowrap

				.settings-section
					display: flex
					flex-direction: row
					flex-wrap: wrap
					margin: 1rem
					margin-bottom: 0
					border-bottom: 1px solid rgba(0,0,0,0.2)
					padding-bottom: 1rem

					.settings-group
						padding: 0 1rem
						width: 50%

						.form-group
							margin-bottom: 1rem

				.settings-section.amazon-s3
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 20px

					> label.no-margin
						margin-bottom: 0

					.description
						margin-bottom: 20px

				.settings-section.releases, .settings-section.publishers-access, .settings-section.files
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem
					user-select: none

					> .description
						margin-bottom: 20px

				.settings-section.creative-markers
					flex-direction: column
					flex-wrap: nowrap
					padding: 0 1rem
					padding-bottom: 1rem

					> label
						margin-bottom: 0

					.description
						margin-bottom: 20px

					.caption
						margin-bottom: 5px

						input
							width: 150px
							height: calc(0.75rem + 0.75rem + 8px)
							margin-right: 10px
							padding: 0.25rem 0.5rem

						button
							width: auto

					i.fa.fa-remove
						display: none
						cursor: pointer
						margin-left: 5px

					.marker:hover

						i.fa.fa-remove
							display: inline

				.columns-2
					display: flex
					flex-direction: row
					flex-wrap: nowrap

					.column
						display: flex
						flex-direction: column
						width: 50%
						padding-right: 1rem

					.row
						display: flex
						flex-direction: row
						width: 50%
						padding-right: 1rem

				.columns-3
					display: flex
					flex-direction: row
					flex-wrap: nowrap

					.column
						display: flex
						flex-direction: column
						width: 33%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: flex-start
							justify-content: flex-start

							label.switch
								margin-left: 10px

						.form-group.inline
							flex-direction: row
							align-items: center

						.form-group.no-margin
							margin-bottom: 0

				.columns-4
					display: flex
					flex-direction: row
					flex-wrap: nowrap

					.column
						display: flex
						flex-direction: column
						width: 25%
						padding-right: 1rem

						.form-group
							display: flex
							flex-direction: column
							align-items: flex-start
							justify-content: flex-start

							label.switch
								margin-left: 10px

						.form-group.inline
							flex-direction: row
							align-items: center

						.form-group.no-margin
							margin-bottom: 0

			.main-menu-markers
				margin-top: 20px


		label
			margin-bottom: 0.5rem

		input[type="text"]
			width: 100%
			height: calc(1.5em + 0.75rem + 2px)
			padding: 0.375rem 0.75rem
			font-size: 0.875rem
			font-weight: 400
			line-height: 1.5
			color: rgba(255, 255, 255, 0.87)
			background-color: rgba(255, 255, 255, 0.05)
			border: 1px solid rgba(255, 255, 255, 0.09)
			border-radius: 0.25rem
			transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out

		.multi-select-checkbox
			margin-bottom: 10px

			label
				margin-bottom: 0
				cursor: pointer

				.form-check-input
					top: -1px

				input
					cursor: pointer

		.custom-select
			width: auto

		.content-left
			justify-content: end

	@media screen and (max-width: 600px)

		.publisher-settings

			.page-center-content

				.settings-groups-area

					.settings-group
						width: 100%

</style>

